import "react-toastify/dist/ReactToastify.css";
import "./main.scss";

import { Appcues, Loader } from "appcues-loader";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";

import { ScrollToTop } from "./components/common/scrollToTop";
import { NavBar } from "./components/navbar";
import { onMessageListener } from "./firebase/firebase";
import { setAppToken } from "./setup/context/api";
import { AuthConfig } from "./setup/context/config/authConfig";
import Routes from "./setup/routes";

declare const window;
export const App = () => {
  const userInfo = AuthConfig.getMyInfo();
  const appcuesUserId = process.env.REACT_APP_APPCUES_ACCOUNT_ID;
  const notificationTitle = useTranslation().t("lbl_new_notification");

  useEffect(() => {
    const loader = new Loader(appcuesUserId);
    loader.load().then((appcues: Appcues) => {
      appcues.page();
    });

    window.Appcues.identify(
      `<<< ${userInfo?.id} >>>`, // unique, required
      {
        createdAt: new Date().toLocaleTimeString(), // Unix timestamp of user signup date
        planTier: "Standard", // Current user’s plan tier
        role: "User", // Current user’s role or permissions
        accountId: userInfo?.id, // Current user's account ID
        firstName: userInfo?.profile?.firstName, // current user's first name
        email: `${userInfo?.id}@dev-waffyapp.com`, // Current user's email
        language: "arabic", // for multi-language applications
      }
    );
  }, [appcuesUserId, userInfo?.id, userInfo?.profile?.firstName]);

  onMessageListener()
    .then(() => {
      toast.info(<h4> {notificationTitle} </h4>);
    })
    .catch((err) => console.log("failed: ", err));
  return (
    <div dir="rtl">
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1"
      />
      <ScrollToTop path="/">
        <Router>
          <ToastContainer rtl={true} />
          <NavBar />
          <Routes />
        </Router>
      </ScrollToTop>
    </div>
  );
};
setAppToken();
